var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnounce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.528.14c-1.1.001-2.06.745-2.337 1.81L4.996 6.353c-.028-.286-.27-.503-.556-.502H1.267c-.307 0-.556.25-.556.557v5.405c0 .308.249.558.556.558h3.2c.218-.004.414-.135.501-.335l2.588.725v4.931c0 .308.25.558.557.558h8.655c.307 0 .556-.25.556-.558V15.52l2.894.808c.318 1.181 1.465 1.94 2.675 1.77 1.21-.17 2.104-1.215 2.084-2.439V2.563c0-.647-.259-1.268-.719-1.724-.46-.455-1.083-.707-1.73-.7zM4.996 7.522L20.107 3.12v12.036L5.024 10.894l-.028-3.371zm-1.113 3.761h-2.06V6.965h2.06v4.32zm12.328 5.851H8.67v-4.04l7.541 2.118v1.922zm7.653-1.477c0 .724-.586 1.31-1.308 1.31-.722 0-1.308-.586-1.308-1.31V2.563c0-.723.586-1.31 1.308-1.31.722 0 1.308.587 1.308 1.31v13.095z",
    transform: "translate(-289 -544) translate(276 531) translate(13.878 13) translate(0 4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounce);
export default __webpack_public_path__ + "static/media/announce.c366dfbf.svg";
export { ForwardRef as ReactComponent };